import React, {} from 'react';
import ScrollView from 'devextreme-react/scroll-view';
import './single-card.scss';
import {Link} from "react-router-dom";
//import './../../../public/css/tatenergosbyt/additional.scss';
const SingleCard = ({ title, description, children, className }) => {
    document.title = process.env['REACT_APP_TITLE'] + " - " + title
    return (
        <ScrollView height={'100%'} width={'100%'} useNative={true} className={`with-footer single-card ${className}`}>
            <div className={'dx-card content'}>
                <div className={'header'}>
                    <Link className="navbar-brand gradientsvg" to="/">
                        <img alt={`Логотип ` + process.env['REACT_APP_TITLE']} style={{ height: '3rem' }} src={process.env['REACT_APP_LOGO']}/>
                    </Link>
                    <Link className="homemain" to="/">
                        <img alt={`Логотип ` + process.env['REACT_APP_TITLE']}
                             style={process.env['REACT_APP_HEIGHT_LOGO_PODPIS'] ? { height: process.env['REACT_APP_HEIGHT_LOGO_PODPIS']}:{ height: '2rem' }}
                             src={process.env['REACT_APP_LOGO_PODPIS']}/>
                    </Link>
                    <div className={'title'}>{title}</div>
                    {description &&
                    <div className={'description'}>{description}</div>
                    }
                </div>
                {children}
            </div>
        </ScrollView>
    );
}

export default SingleCard
